import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./Home.css";
import IntroAnimation from "./IntroAnimation.js";
import aboutImg from "./../assets/home/abCover.webp";

import Testimonials from "./Testimonials.js";
import { Link } from "react-router-dom";    

import PergolaCover from "./../assets/home/PergolaCover.jpg";
import PartitionCover from "./../assets/home/PartitionCover.jpg";
import DoorCover from "./../assets/home/DoorCover.jpg";
import SwingDoorCover from "./../assets/home/SwingDoorCover.jpg"; 

// Import images for each project
import pergola1 from "./../assets/home/pergola1.jpg";
import pergola2 from "./../assets/home/pergola2.jpg";
import pergola3 from "./../assets/home/pergola3.jpg";
import pergola4 from "./../assets/home/pergola4.jpg";


const Home = () => {
  return (
    <div>
      <main>
        <IntroAnimation /> {/* Use the IntroAnimation component */}
        <div className="hero bg-cover bg-center flex items-center pt-5 md:pt-10 flex-col h-screen">
          <h1 className="text-[#36454F] text-center font-montserrat text-4xl md:text-6xl md:pb-2 font-normal leading-8 tracking-widest uppercase">
            ASTRA CONCEPTS
          </h1>
          <p className="text-[#36454F] text-center font-montserrat pt-2 md:pt-4 text-lg md:text-lg font-light leading-8 tracking-wider uppercase">
            Aluminum Design Systems
          </p>
        </div>

        {/* Projects Section */}
        <div className="flex flex-col justify-center md:pt-32 bg-white">
          <h3 className="text-4xl md:text-6xl text-center leading-8 font-montserrat font-medium tracking-wide md:tracking-widest">
            OUR WORK
          </h3>
          <p className="font-montserrat font-medium text-center md:space-x-5 space-y-3 md:space-y-0 max-w-full md:max-w-7xl mx-auto px-10 pt-6 pb-10 text-md">
            Explore our recent projects, including custom aluminum pergolas, partitions, and more.
          </p>

          {/* Projects Carousel */}
          <div className="flex flex-col items-center pt-2 pb-6 max-w-7xl mx-auto">
            <Carousel
              className="projects-carousel"
              autoPlay
              infiniteLoop
              showThumbs={false}
              showStatus={false}
              interval={5000}
              transitionTime={500}
            >
              <div>
                <img
                  src={pergola1}
                  alt="Pergola Project 1"
                  className="object-cover w-full h-64"
                />
              </div>
              <div>
                <img
                  src={pergola2}
                  alt="Pergola Project 2"
                  className="object-cover w-full h-64"
                />
              </div>
              <div>
                <img
                  src={pergola3}
                  alt="Pergola Project 3"
                  className="object-cover w-full h-64"
                />
              </div>
              <div>
                <img
                  src={pergola4}
                  alt="Pergola Project 4"
                  className="object-cover w-full h-64"
                />
              </div>
            </Carousel>
          </div>

          {/* View Projects Button */}
          <div className="flex justify-center">
            <Link to="/gallery">
              <button className="bg-black hover:bg-gray-700 text-xs font-montserrat font-normal text-white py-2 px-12 w-full md:w-full transform transition duration-500">
                View All Projects
              </button>
            </Link>
          </div>
        </div>

        {/* About Us Section */}
        <div className="flex flex-col justify-center pt-24 md:pt-32 bg-white">
          <div className="max-w-5xl mx-auto text-center px-6 md:px-12">
            <h3 className="text-4xl md:text-6xl font-montserrat font-medium tracking-wide md:tracking-widest text-[#36454F]">
              ABOUT US
            </h3>
            <p className="font-montserrat font-medium text-md md:text-lg leading-8 tracking-wide text-[#36454F] mt-6">
              At Astra Concepts, we specialize in creating innovative aluminum solutions, including pergolas, partitions, and more. 
              Our mission is to transform your spaces with modern, functional, and stylish designs that stand the test of time.
            </p>
            <div className="mt-8">
              <Link to="about">
                <button className="bg-black hover:bg-gray-700 text-xs md:text-sm font-montserrat font-normal text-white py-3 px-8 md:px-12 transform transition duration-500">
                  Learn More
                </button>
              </Link>
            </div>
          </div>
        </div>

        {/* Collections Section */}
        <div className="flex flex-col justify-center pt-24 md:pt-32 bg-white">
          <h3 className="text-4xl md:text-6xl text-center leading-8 font-montserrat font-medium tracking-wide md:tracking-widest">
            OUR SYSTEMS
          </h3>
          <p className="font-montserrat font-medium text-center md:space-x-5 space-y-3 md:space-y-0 max-w-full md:max-w-5xl mx-auto px-10 pt-6 pb-10 text-md">
            Discover our range of aluminum products, designed to enhance your living spaces with style and functionality.
          </p>

          {/* Product Grid */}
          <div className="flex flex-col justify-center pt-2 pb-24">
            <div className="grid grid-cols-1 gap-12 max-w-5xl mx-auto">
              <div className="w-full bg-white transform transition duration-500 hover:scale-105">
                <Link to="products/pergolas">
                  <img
                    src={PergolaCover}
                    alt="pergola cover"
                    className="object-cover w-full h-full"
                  />
                </Link>
                <span className="font-montserrat font-bold text-center block pb-3 text-sm tracking-wide pt-2">
                  PERGOLAS
                </span>
              </div>
              <div className="w-full bg-white transform transition duration-500 hover:scale-105">
                <Link to="products/partitions">
                  <img
                    src={PartitionCover}
                    alt="partition cover"
                    className="object-cover w-full h-full"
                  />
                </Link>
                <span className="font-montserrat font-bold text-center block pb-3 text-sm tracking-wide pt-2">
                  PARTITIONS
                </span>
              </div>
              <div className="w-full bg-white transform transition duration-500 hover:scale-105">
                <Link to="products/sliders">
                  <img
                    src={DoorCover}
                    alt="door cover"
                    className="object-cover w-full h-full"
                  />
                </Link>
                <span className="font-montserrat font-bold text-center block pb-3 text-sm tracking-wide pt-2">
                  SLIDING DOORS
                </span>
              </div>
              <div className="w-full bg-white transform transition duration-500 hover:scale-105">
                <Link to="products/doors">
                  <img
                    src={SwingDoorCover}
                    alt="door cover"
                    className="object-cover w-full h-full"
                  />
                </Link>
                <span className="font-montserrat font-bold text-center block pb-3 text-sm tracking-wide pt-2">
                  INTERIOR DOORS
                </span>
              </div>
            </div>
          </div>
        </div>

        <section className="bg-[#F1F1F1] mt-12">
          <div className="py-8 px-4 mx-auto max-w-screen-xl sm:py-16 lg:px-6">
            <div className="mx-auto max-w-screen-sm text-center">
              <h2 className="font-montserrat font-semibold mb-4 md:text-4xl text-lg tracking-tight font-extrabold leading-tight">
                Contact us to find out more
              </h2>
              <p className="font-montserrat font-medium mb-6 font-light md:text-lg">
                Upgrade your spaces with Astra Concepts today! Discover the perfect blend of luxury and functionality.
              </p>
              <Link className="text-left" to="contact">
                <button className="bg-black hover:bg-gray-700 text-xs font-montserrat font-normal text-white py-2 px-4 w-full md:w-1/2 transform transition duration-500">
                  GET IN TOUCH
                </button>
              </Link>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Home;
